import { getGlobalStoreHook } from '@core/store';
/**
 *
 */
export function useGlobalStore(selector, equalityFn) {
    return getGlobalStoreHook()(selector, equalityFn);
}
